var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content businessIntelligenceDashboard" },
    [
      _c(
        "div",
        { staticClass: "tab-list" },
        _vm._l(_vm.tabList, function(item, index) {
          return _c(
            "span",
            {
              key: index,
              staticClass: "tab-item",
              class: { selectColor: _vm.tabIndex === item.dashboardId },
              on: {
                click: function($event) {
                  return _vm.selectMenuItem(item, item.dashboardId)
                }
              }
            },
            [_vm._v(_vm._s(item.name))]
          )
        }),
        0
      ),
      _c("div", { staticClass: "dashboard-right" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.entrance === "TAB",
                expression: "entrance === 'TAB'"
              }
            ],
            staticClass: "operation"
          },
          [
            _c(
              "el-button",
              { attrs: { type: "primary" }, on: { click: _vm.addDashboard } },
              [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "BusinessIntelligence.businessIntelligenceDashboard.addDashboard"
                    )
                  )
                )
              ]
            ),
            _c(
              "el-button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      _vm.tabItem.name !==
                        _vm.$t("BiAnalysis.DefaultDashboard") &&
                      _vm.tabItem.name,
                    expression:
                      "tabItem.name !== $t('BiAnalysis.DefaultDashboard') && tabItem.name"
                  }
                ],
                attrs: { type: "primary" },
                on: { click: _vm.editDashboard }
              },
              [_vm._v(_vm._s(_vm.$t("BusinessIntelligence.common.edit")))]
            ),
            _c(
              "el-button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.tabItem.name,
                    expression: "tabItem.name"
                  }
                ],
                attrs: { type: "danger" },
                on: { click: _vm.deleteDashboardFunc }
              },
              [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "BusinessIntelligence.businessIntelligenceDashboard.delete"
                    )
                  )
                )
              ]
            )
          ],
          1
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.entrance !== "TAB",
                expression: "entrance !== 'TAB'"
              }
            ],
            staticClass: "operation"
          },
          [
            _c(
              "el-button",
              { attrs: { type: "primary" }, on: { click: _vm.fullScreen } },
              [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "BusinessIntelligence.businessIntelligenceDashboard.fullScreen"
                    )
                  )
                )
              ]
            )
          ],
          1
        ),
        _c("div", { staticClass: "section dashboard" }, [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.tabItem.type === 1 && _vm.entrance === "TAB",
                  expression: "tabItem.type === 1 && entrance === 'TAB'"
                }
              ],
              staticClass: "custom-operation"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.settingFilters }
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "BusinessIntelligence.businessIntelligenceDashboard.setFilter"
                      )
                    )
                  )
                ]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.preview } },
                [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "BusinessIntelligence.businessIntelligenceDashboard.preview"
                      )
                    )
                  )
                ]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.saveLayout } },
                [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "BusinessIntelligence.businessIntelligenceDashboard.saveLayout"
                      )
                    )
                  )
                ]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.addChart } },
                [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "BusinessIntelligence.businessIntelligenceDashboard.addChart"
                      )
                    )
                  )
                ]
              )
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.tabItem.type === 1 && _vm.entrance === "TAB",
                  expression: "tabItem.type === 1 && entrance === 'TAB'"
                }
              ],
              staticStyle: {
                display: "flex",
                "justify-content": "space-between",
                "align-items": "center"
              }
            },
            [
              _c(
                "div",
                { staticStyle: { margin: "10px 0", "font-size": "16px" } },
                [_vm._v(_vm._s(_vm.tabItem.name))]
              ),
              _c(
                "span",
                { staticStyle: { "font-size": "14px", color: "#409eff" } },
                [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "BusinessIntelligence.businessIntelligenceDashboard.dragTips"
                      )
                    )
                  )
                ]
              )
            ]
          ),
          _c(
            "div",
            {
              staticClass: "dashboard-content",
              class: {
                scroll:
                  _vm.freeDashboard ||
                  (_vm.tabItem.type === 1 && _vm.entrance === "TAB")
              }
            },
            [
              _vm.freeDashboard && _vm.isBiDashboard
                ? _c("img", {
                    attrs: { src: _vm.matchImg(_vm.tabItem.name) },
                    on: {
                      click: function($event) {
                        return _vm.defaultDashboardClicked()
                      }
                    }
                  })
                : _vm._e(),
              !_vm.freeDashboard && _vm.isBiDashboard
                ? _c(
                    "div",
                    {
                      ref: "iframeContainer",
                      staticStyle: {
                        position: "relative",
                        width: "100%",
                        height: "100%"
                      },
                      attrs: { id: "iframeContainer" }
                    },
                    [
                      _vm.freeCustomer
                        ? _c("div", {
                            staticStyle: {
                              position: "absolute",
                              top: "0",
                              bottom: "0",
                              right: "0",
                              left: "0"
                            },
                            on: {
                              click: function($event) {
                                return _vm.defaultDashboardClicked()
                              }
                            }
                          })
                        : _vm._e(),
                      !_vm.freeDashboard && _vm.isBiDashboard
                        ? _c("iframe", {
                            ref: "dashboardIframe",
                            attrs: {
                              id: "dashboardIframe",
                              src: _vm.tabItem.url,
                              frameborder: "0",
                              allowtransparency: "",
                              width: "100%",
                              height: "100%"
                            }
                          })
                        : _vm._e()
                    ]
                  )
                : _vm._e(),
              _c(
                "grid-layout",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.tabItem.type === 1 && _vm.entrance === "TAB",
                      expression: "tabItem.type === 1 && entrance === 'TAB'"
                    }
                  ],
                  attrs: {
                    layout: _vm.customChart,
                    "col-num": 18,
                    "row-height": 60,
                    "is-draggable": true,
                    "is-resizable": true,
                    "is-mirrored": false,
                    "auto-size": true,
                    "use-css-transforms": true,
                    "vertical-compact": true,
                    margin: [10, 10]
                  },
                  on: {
                    "update:layout": function($event) {
                      _vm.customChart = $event
                    }
                  }
                },
                _vm._l(_vm.customChart, function(item) {
                  return _c(
                    "grid-item",
                    {
                      key: item.i,
                      attrs: {
                        x: item.x,
                        y: item.y,
                        w: item.w,
                        h: item.h,
                        i: item.i
                      }
                    },
                    [
                      _c("div", { staticClass: "dashboard-item" }, [
                        _c("div", { staticStyle: { flex: "1" } }, [
                          _c("iframe", {
                            attrs: {
                              src: item.url,
                              frameborder: "0",
                              scrolling: "no",
                              allowtransparency: "",
                              width: "100%",
                              height: "100%"
                            }
                          })
                        ]),
                        _c("div", { staticClass: "dashboard-item-operation" }, [
                          _c("span", [_vm._v(_vm._s(item.name))]),
                          _c("span", [
                            _c("i", {
                              staticClass: "el-icon-close",
                              on: {
                                click: function($event) {
                                  return _vm.deletes(item)
                                }
                              }
                            })
                          ])
                        ])
                      ])
                    ]
                  )
                }),
                1
              )
            ],
            1
          )
        ])
      ]),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.addDashboardShow,
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            "modal-append-to-body": false,
            "show-close": false,
            title: _vm.dialogTitle,
            editable: true,
            width:
              _vm.dashboardForm.type === 1 && _vm.dialogType === "add"
                ? "900px"
                : "450px"
          },
          on: {
            "update:visible": function($event) {
              _vm.addDashboardShow = $event
            }
          }
        },
        [
          _c("div", { staticClass: "dialog-content" }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.addChartShow,
                    expression: "!addChartShow"
                  }
                ],
                staticClass: "content-left"
              },
              [
                _c(
                  "el-form",
                  {
                    ref: "form",
                    attrs: {
                      inline: true,
                      model: _vm.dashboardForm,
                      "label-width": "100px",
                      rules: _vm.rules
                    },
                    nativeOn: {
                      submit: function($event) {
                        $event.preventDefault()
                      }
                    }
                  },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t(
                            "BusinessIntelligence.businessIntelligenceDashboard.dashboardType"
                          ),
                          prop: "type",
                          "show-message": false
                        }
                      },
                      [
                        _c(
                          "el-radio-group",
                          {
                            model: {
                              value: _vm.dashboardForm.type,
                              callback: function($$v) {
                                _vm.$set(_vm.dashboardForm, "type", $$v)
                              },
                              expression: "dashboardForm.type"
                            }
                          },
                          [
                            _c(
                              "el-radio",
                              {
                                attrs: {
                                  label: 1,
                                  disabled: _vm.dialogType === "edit"
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "BusinessIntelligence.businessIntelligenceDashboard.customizeDashboard"
                                    )
                                  )
                                )
                              ]
                            ),
                            _c(
                              "el-radio",
                              {
                                attrs: {
                                  label: 0,
                                  disabled: _vm.dialogType === "edit"
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "BusinessIntelligence.businessIntelligenceDashboard.biDashboard"
                                    )
                                  )
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t(
                            "BusinessIntelligence.businessIntelligenceDashboard.dashboardName"
                          ),
                          prop: "name",
                          "show-message": false
                        }
                      },
                      [
                        _c("el-input", {
                          staticClass: "input-width",
                          attrs: {
                            placeholder: _vm.$t(
                              "BusinessIntelligence.businessIntelligenceDashboard.dashboardNamePlaceholder"
                            )
                          },
                          model: {
                            value: _vm.dashboardForm.name,
                            callback: function($$v) {
                              _vm.$set(_vm.dashboardForm, "name", $$v)
                            },
                            expression: "dashboardForm.name"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.dashboardForm.type === 1,
                            expression: "dashboardForm.type === 1"
                          }
                        ],
                        attrs: {
                          label: _vm.$t(
                            "BusinessIntelligence.businessIntelligenceDashboard.classification"
                          ),
                          "show-message": false
                        }
                      },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "200px" },
                            on: { change: _vm.selectDashbaordType },
                            model: {
                              value: _vm.dashboardForm.dashboardType,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.dashboardForm,
                                  "dashboardType",
                                  $$v
                                )
                              },
                              expression: "dashboardForm.dashboardType"
                            }
                          },
                          _vm._l(_vm.dashboardTypeList, function(item) {
                            return _c("el-option", {
                              key: item.id,
                              attrs: { label: item.name, value: item.id }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.dashboardForm.type === 0,
                            expression: "dashboardForm.type === 0"
                          }
                        ],
                        attrs: {
                          label: _vm.$t("BiAnalysis.BIDashboardSource"),
                          prop: "biDashboardSource",
                          "show-message": false
                        }
                      },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "200px" },
                            attrs: {
                              disabled:
                                _vm.dialogType === "edit" && !_vm.freeDashboard
                            },
                            model: {
                              value: _vm.dashboardForm.biDashboardSource,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.dashboardForm,
                                  "biDashboardSource",
                                  $$v
                                )
                              },
                              expression: "dashboardForm.biDashboardSource"
                            }
                          },
                          _vm._l(_vm.domaineNames, function(item, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: { value: item }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.dashboardForm.type === 0,
                            expression: "dashboardForm.type === 0"
                          }
                        ],
                        attrs: {
                          label: _vm.$t(
                            "BusinessIntelligence.businessIntelligenceDashboard.biDashboardId"
                          ),
                          prop: "dashboardId",
                          "show-message": false
                        }
                      },
                      [
                        _c("el-input", {
                          staticClass: "input-width",
                          attrs: {
                            disabled:
                              _vm.dialogType === "edit" && !_vm.freeDashboard,
                            placeholder: _vm.$t(
                              "BusinessIntelligence.businessIntelligenceDashboard.biDashboardIdPlaceholder"
                            )
                          },
                          model: {
                            value: _vm.dashboardForm.dashboardId,
                            callback: function($$v) {
                              _vm.$set(_vm.dashboardForm, "dashboardId", $$v)
                            },
                            expression: "dashboardForm.dashboardId"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t(
                            "BusinessIntelligence.businessIntelligenceDashboard.Notes"
                          ),
                          "show-message": false
                        }
                      },
                      [
                        _c("el-input", {
                          staticStyle: { width: "250px" },
                          attrs: { type: "textarea", rows: 5 },
                          model: {
                            value: _vm.dashboardForm.remark,
                            callback: function($$v) {
                              _vm.$set(_vm.dashboardForm, "remark", $$v)
                            },
                            expression: "dashboardForm.remark"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "permissions" },
                      [
                        _c("div", { staticClass: "permissions-title" }, [
                          _c("i", { staticClass: "color-piece" }),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "BusinessIntelligence.businessIntelligenceDashboard.setAccessRights"
                                )
                              )
                            )
                          ]),
                          _c("i", {
                            staticClass: "el-icon-warning",
                            staticStyle: {
                              "font-size": "14px",
                              color: "#1F75D5"
                            },
                            on: { click: _vm.prompt }
                          })
                        ]),
                        _c(
                          "div",
                          { staticClass: "align-center" },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t(
                                    "BusinessIntelligence.businessIntelligenceDashboard.selectBranch"
                                  ),
                                  prop: "accessCompanyId",
                                  "show-message": false
                                }
                              },
                              [
                                _c("cargo-advance-select", {
                                  staticStyle: { width: "200px" },
                                  attrs: {
                                    "filter-type": "global",
                                    "filter-tag-names": ["name", "code"],
                                    disabled: _vm.selectAllBranch,
                                    "static-options":
                                      _vm.accessPermissions.branchList,
                                    placeholder: _vm.$t(
                                      "BusinessIntelligence.businessIntelligenceDashboard.selectBranchPlaceholder"
                                    ),
                                    filterable: "",
                                    multiple: "",
                                    "tag-name": "code",
                                    "default-multiple-value":
                                      _vm.accessCompanyList
                                  },
                                  on: {
                                    parentCallBack: function(p) {
                                      return _vm.selectBranch(p)
                                    }
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "el-checkbox",
                              {
                                on: { change: _vm.changeBranchAll },
                                model: {
                                  value: _vm.selectAllBranch,
                                  callback: function($$v) {
                                    _vm.selectAllBranch = $$v
                                  },
                                  expression: "selectAllBranch"
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "BusinessIntelligence.businessIntelligence.all"
                                    )
                                  )
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "align-center" },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t(
                                    "BusinessIntelligence.businessIntelligenceDashboard.selectDepartment"
                                  ),
                                  "show-message": false
                                }
                              },
                              [
                                _c("cargo-advance-select", {
                                  staticStyle: { width: "200px" },
                                  attrs: {
                                    disabled:
                                      _vm.selectAllDepartment ||
                                      _vm.selectAllBranch,
                                    "static-options":
                                      _vm.accessPermissions.departmentList,
                                    placeholder: _vm.$t(
                                      "BusinessIntelligence.businessIntelligenceDashboard.selectDepartmentPlaceholder"
                                    ),
                                    filterable: "",
                                    multiple: "",
                                    "tag-name": "chineseName",
                                    "tag-value": "departmentId",
                                    "default-multiple-value":
                                      _vm.dashboardForm.accessDeptId,
                                    "show-custom-label-in-option": true,
                                    "custom-label": _vm.toDepartmentLabel,
                                    "filter-after-fetch-data": true
                                  },
                                  on: { parentCallBack: _vm.getPersonnelList }
                                })
                              ],
                              1
                            ),
                            _c(
                              "el-checkbox",
                              {
                                attrs: { disabled: _vm.selectAllBranch },
                                on: { change: _vm.changeDepartmentAll },
                                model: {
                                  value: _vm.selectAllDepartment,
                                  callback: function($$v) {
                                    _vm.selectAllDepartment = $$v
                                  },
                                  expression: "selectAllDepartment"
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "BusinessIntelligence.businessIntelligence.all"
                                    )
                                  )
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "align-center" },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t(
                                    "BusinessIntelligence.businessIntelligenceDashboard.selectPersonnel"
                                  ),
                                  "show-message": false
                                }
                              },
                              [
                                _c("cargo-advance-select", {
                                  staticStyle: { width: "200px" },
                                  attrs: {
                                    disabled:
                                      _vm.selectAllPersonnel ||
                                      _vm.selectAllDepartment ||
                                      _vm.selectAllBranch,
                                    "static-options":
                                      _vm.accessPermissions.personnelList,
                                    placeholder: _vm.$t(
                                      "BusinessIntelligence.businessIntelligenceDashboard.selectPersonnelPlaceholder"
                                    ),
                                    filterable: "",
                                    multiple: "",
                                    "tag-name": "chineseName",
                                    "tag-value": "userId",
                                    "default-multiple-value":
                                      _vm.dashboardForm.accessUserId,
                                    "show-custom-label-in-option": true,
                                    "custom-label": _vm.toUserLabel,
                                    "filter-after-fetch-data": true
                                  },
                                  on: {
                                    parentCallBack: function(item) {
                                      return (_vm.dashboardForm.accessUserId =
                                        item.value)
                                    }
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "el-checkbox",
                              {
                                attrs: {
                                  disabled:
                                    _vm.selectAllDepartment ||
                                    _vm.selectAllBranch
                                },
                                on: { change: _vm.changePersonnelAll },
                                model: {
                                  value: _vm.selectAllPersonnel,
                                  callback: function($$v) {
                                    _vm.selectAllPersonnel = $$v
                                  },
                                  expression: "selectAllPersonnel"
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "BusinessIntelligence.businessIntelligence.all"
                                    )
                                  )
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _c("div", { staticClass: "permissions-title" }, [
                          _c("i", { staticClass: "color-piece" }),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "BusinessIntelligence.businessIntelligenceDashboard.setDataPermission"
                                )
                              )
                            )
                          ])
                        ]),
                        _c(
                          "el-checkbox-group",
                          {
                            staticStyle: { "margin-left": "10px" },
                            on: { change: _vm.statusChanges },
                            model: {
                              value: _vm.dashboardForm.dataAccess,
                              callback: function($$v) {
                                _vm.$set(_vm.dashboardForm, "dataAccess", $$v)
                              },
                              expression: "dashboardForm.dataAccess"
                            }
                          },
                          [
                            _c("el-checkbox", { attrs: { label: "0" } }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "BusinessIntelligence.businessIntelligenceDashboard.whole"
                                  )
                                )
                              )
                            ]),
                            _c("el-checkbox", { attrs: { label: "3" } }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "BusinessIntelligence.businessIntelligenceDashboard.personal"
                                  )
                                )
                              )
                            ]),
                            _c("el-checkbox", { attrs: { label: "4" } }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "BusinessIntelligence.businessIntelligenceDashboard.rolePermissions"
                                  )
                                )
                              )
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      (_vm.dashboardForm.type === 1 &&
                        _vm.dialogType === "add") ||
                      _vm.addChartShow,
                    expression:
                      "dashboardForm.type === 1 && dialogType === 'add' || addChartShow"
                  }
                ],
                staticClass: "content-right"
              },
              [
                _c("div", [
                  _c("span", { staticClass: "content-right-title" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "BusinessIntelligence.businessIntelligenceDashboard.chartAddDashboard"
                        )
                      )
                    )
                  ]),
                  _c(
                    "div",
                    { staticClass: "content-right-operation" },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.chartName,
                            expression: "chartName"
                          }
                        ],
                        staticClass: "set-input",
                        attrs: {
                          placeholder: _vm.$t(
                            "BusinessIntelligence.businessIntelligenceDashboard.queryChartName"
                          )
                        },
                        domProps: { value: _vm.chartName },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.chartName = $event.target.value
                          }
                        }
                      }),
                      _c(
                        "el-button",
                        {
                          staticStyle: { "margin-left": "10px" },
                          attrs: { type: "primary" },
                          on: { click: _vm.searchChart }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("BusinessIntelligence.common.query"))
                          )
                        ]
                      )
                    ],
                    1
                  )
                ]),
                _c(
                  "div",
                  { staticStyle: { "margin-top": "10px", flex: "1" } },
                  [
                    _c("cargo-ag-grid", {
                      staticStyle: { height: "100%" },
                      attrs: {
                        "config-module": "2022083101",
                        "grid-options": _vm.gridOptions,
                        "column-defs": _vm.columnDefs,
                        "row-data": _vm.chartList
                      }
                    })
                  ],
                  1
                )
              ]
            )
          ]),
          _c(
            "div",
            { staticStyle: { "text-align": "right", "margin-top": "20px" } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "mini" },
                  on: { click: _vm.dialogConfirm }
                },
                [_vm._v(_vm._s(_vm.$t("BusinessIntelligence.common.save")))]
              ),
              _c(
                "el-button",
                { attrs: { size: "mini" }, on: { click: _vm.dialogCancel } },
                [_vm._v(_vm._s(_vm.$t("BusinessIntelligence.common.cancel")))]
              )
            ],
            1
          )
        ]
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.addChartShow,
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            "modal-append-to-body": false,
            "show-close": false,
            title: _vm.dialogTitle,
            editable: true,
            width: "600px"
          },
          on: {
            "update:visible": function($event) {
              _vm.addChartShow = $event
            }
          }
        },
        [
          _c("div", { staticClass: "dialog-content" }, [
            _c("div", { staticClass: "content-right" }, [
              _c("span", { staticClass: "content-right-title" }, [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "BusinessIntelligence.businessIntelligenceDashboard.chartAddDashboard"
                    )
                  )
                )
              ]),
              _c(
                "div",
                { staticClass: "content-right-operation" },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.chartName,
                        expression: "chartName"
                      }
                    ],
                    staticClass: "set-input",
                    attrs: {
                      placeholder: _vm.$t(
                        "BusinessIntelligence.businessIntelligenceDashboard.queryChartName"
                      )
                    },
                    domProps: { value: _vm.chartName },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.chartName = $event.target.value
                      }
                    }
                  }),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "10px" },
                      attrs: { type: "primary" },
                      on: { click: _vm.filterChart }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("BusinessIntelligence.common.query"))
                      )
                    ]
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticStyle: { "margin-top": "10px" } },
                [
                  _c("cargo-ag-grid", {
                    staticStyle: { height: "300px" },
                    attrs: {
                      "config-module": "2022091901",
                      "grid-options": _vm.gridOptions,
                      "column-defs": _vm.columnDefs,
                      "row-data": _vm.addChartList
                    }
                  })
                ],
                1
              )
            ])
          ]),
          _c(
            "div",
            { staticStyle: { "text-align": "right", "margin-top": "20px" } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "mini" },
                  on: { click: _vm.addChartConfirm }
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "BusinessIntelligence.businessIntelligenceDashboard.add"
                      )
                    )
                  )
                ]
              ),
              _c(
                "el-button",
                { attrs: { size: "mini" }, on: { click: _vm.addChartCancel } },
                [_vm._v(_vm._s(_vm.$t("BusinessIntelligence.common.cancel")))]
              )
            ],
            1
          )
        ]
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.queryItemShow,
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            "modal-append-to-body": false,
            "show-close": false,
            title: _vm.$t(
              "BusinessIntelligence.businessIntelligenceDashboard.setQueryItem"
            ),
            editable: true,
            width: "500px"
          },
          on: {
            "update:visible": function($event) {
              _vm.queryItemShow = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticStyle: { padding: "0 10px", "box-sizing": "border-box" } },
            [
              _c(
                "el-form",
                {
                  attrs: { inline: true },
                  nativeOn: {
                    submit: function($event) {
                      $event.preventDefault()
                    }
                  }
                },
                [
                  _c(
                    "div",
                    { staticStyle: { display: "flex", "flex-wrap": "wrap" } },
                    _vm._l(_vm.queryItem, function(item, index) {
                      return _c("el-checkbox", {
                        key: index,
                        staticStyle: { margin: "0", width: "25%" },
                        attrs: { label: item.name },
                        model: {
                          value: item.selected,
                          callback: function($$v) {
                            _vm.$set(item, "selected", $$v)
                          },
                          expression: "item.selected"
                        }
                      })
                    }),
                    1
                  )
                ]
              ),
              _c("div", { staticClass: "query-item-footer" }, [
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "BusinessIntelligence.businessIntelligenceDashboard.seePreview"
                      )
                    )
                  )
                ]),
                _c(
                  "div",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "mini" },
                        on: { click: _vm.queryItemSave }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "BusinessIntelligence.businessIntelligenceDashboard.determine"
                            )
                          )
                        )
                      ]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "mini" },
                        on: {
                          click: function($event) {
                            _vm.queryItemShow = false
                          }
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("BusinessIntelligence.common.cancel"))
                        )
                      ]
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        ]
      ),
      _c("transition", { attrs: { name: "el-fade-in-linear" } }, [
        _vm.previewShow
          ? _c("div", { staticClass: "mask" }, [
              _c("div", { staticClass: "mask-content" }, [
                _c("i", {
                  staticClass: "el-icon-close close",
                  on: {
                    click: function($event) {
                      _vm.previewShow = false
                    }
                  }
                }),
                _c("iframe", {
                  attrs: {
                    src: _vm.tabItem.url,
                    frameborder: "0",
                    allowtransparency: "",
                    scrolling: "yes",
                    width: "100%",
                    height: "100%"
                  }
                })
              ])
            ])
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }